export default __webpack_public_path__ + "static/media/live-oak-crop.b16b0335.jpg";